import { type StateCreator } from 'zustand';
import { SortingOptionId } from '@pkgs/components/enums/enums';
import { type RangeFilter } from '@ev-tech/search-modules-api';

import { DEFAULT_PREFERENCES } from './preferencesSlice';
import { DEFAULT_SORTING_OPTION_ID } from './optionsSlice';
import { usePromptStore } from '../usePromptStore';
import { type MiddlewareType, type SearchStore } from '../SearchStoreProvider';

export type RangesState = {
  price?: RangeFilter;
  plotSurface?: RangeFilter;
  totalSurface?: RangeFilter;
  rooms?: RangeFilter;
  bathrooms?: RangeFilter;
  bedrooms?: RangeFilter;
  constructionYear?: RangeFilter;
};

type RangesActions = {
  setPrice: (price?: RangeFilter) => void;
  setPlotSurface: (plotSurface?: RangeFilter) => void;
  setTotalSurface: (totalSurface?: RangeFilter) => void;
  setRooms: (rooms?: RangeFilter) => void;
  setBathrooms: (bathrooms?: RangeFilter) => void;
  setBedrooms: (bedrooms?: RangeFilter) => void;
  setConstructionYear: (constructionYear?: RangeFilter) => void;
};

export type RangesStore = RangesState & RangesActions;

export const defaultRangesState: Readonly<RangesState> = {
  price: undefined,
  plotSurface: undefined,
  totalSurface: undefined,
  rooms: undefined,
  bathrooms: undefined,
  bedrooms: undefined,
  constructionYear: undefined,
};

export const createRangesSlice: StateCreator<SearchStore, MiddlewareType, [], RangesStore> = (set, get) => ({
  ...defaultRangesState,
  setPrice: (price?: RangeFilter) => {
    set(
      {
        price,
        page: 1,
        preferences: DEFAULT_PREFERENCES,
        ...(get().sortingOptionId === SortingOptionId.PREFERENCES && { sortingOptionId: DEFAULT_SORTING_OPTION_ID }),
      },
      undefined,
      'setPrice',
    );
    usePromptStore.getState().setPromptValue('');
  },
  setPlotSurface: (plotSurface?: RangeFilter) => {
    set(
      {
        plotSurface,
        page: 1,
        preferences: DEFAULT_PREFERENCES,
        ...(get().sortingOptionId === SortingOptionId.PREFERENCES && { sortingOptionId: DEFAULT_SORTING_OPTION_ID }),
      },
      undefined,
      'setPlotSurface',
    );
    usePromptStore.getState().setPromptValue('');
  },
  setTotalSurface: (totalSurface?: RangeFilter) => {
    set(
      {
        totalSurface,
        page: 1,
        preferences: DEFAULT_PREFERENCES,
        ...(get().sortingOptionId === SortingOptionId.PREFERENCES && { sortingOptionId: DEFAULT_SORTING_OPTION_ID }),
      },
      undefined,
      'setTotalSurface',
    );
    usePromptStore.getState().setPromptValue('');
  },
  setRooms: (rooms?: RangeFilter) => {
    set(
      {
        rooms,
        page: 1,
        preferences: DEFAULT_PREFERENCES,
      },
      undefined,
      'setRooms',
    );
    usePromptStore.getState().setPromptValue('');
  },
  setBathrooms: (bathrooms?: RangeFilter) => {
    set({ bathrooms, page: 1, preferences: DEFAULT_PREFERENCES }, undefined, 'setBathrooms');
    usePromptStore.getState().setPromptValue('');
  },
  setBedrooms: (bedrooms?: RangeFilter) => {
    set({ bedrooms, page: 1, preferences: DEFAULT_PREFERENCES }, undefined, 'setBedrooms');
    usePromptStore.getState().setPromptValue('');
  },
  setConstructionYear: (constructionYear?: RangeFilter) => {
    set({ constructionYear, page: 1, preferences: DEFAULT_PREFERENCES }, undefined, 'setConstructionYear');
    usePromptStore.getState().setPromptValue('');
  },
});
